import React, {Component} from 'react';
import {  Link } from 'react-router-dom';
import axios from 'axios';
// const querystring = require('querystring');
export default class ManageJournal extends Component {

	constructor(props)
	{
		console.log(props);
		super(props);
				let parms = "";
// 				JSON.stringify(querystring.parse(this.props.location.search)).replace('?', '');
        console.log("parms => " + parms);

		this.state={
			"journal" : {
					"journalsId": JSON.parse(parms).id,
				  "journalName": "",
				  "ownerUserId": 0,
				  "projectId": 0,
				  "desktopId": 0,
				  "contentId": 0,
				  "securityContextId": 0,
				  "journalStatusCode": 0,
				  "journalDescr": "",
				  "journalEntry": "",
				  "journalAlertFlag": true,
				  "journalReminderFlag": true,
				  "journalAttachments": "",
				  "journalParticipants": "",
				  "journalEntryDate": new Date(),
				  "effectiveDate": new Date(),
				  "expirationDate": new Date(),
				  "createUser": 0,
				  "createDate": new Date(),
				  "lastUpdateUser": 0,
				  "lastUpdateDate": new Date()
				  },
				  journalStatusCodeList : []
		}
		this.handleChange = this.handleChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.handleOnLoad = this.handleOnLoad.bind(this);
	}
	handleChange(event) {
		console.log(event);
		var target = event.target;
		console.log(target.id + ":" + target.value);
		this.setState({
			[target.id] : target.value
		});
	   
		console.log(this.state);
	  }
	handleSubmit(event) {

		event.preventDefault();
		console.log('handling submit');  
	
	  var url = `${global.config.apiServicesUrl}/journals`;
//	  var idUrl = "${global.config.securityServicesUrl}/next-id-generator/get-next/journals/journalsId";
	
//	  axios.get(idUrl)
//		  .then(response => {
//			  this.setState({generalledgerId : response.data["nextId"]});
//		  
//			  //console.log("new category id = " + JSON.stringifyt(this.state.journal.contentCategoriesObject.contentCategoryId));
//		
//			console.log("request object = " + JSON.stringify(this.state));
	  		this.state.journal.lastUpdateUser = Number(this.props.userId);

			axios
			  .post(url, this.state)
			  .then(response2 => {
			console.log("response.data");
			console.log(response2.status +":"+response2.data.accountId);
			// && response2.data.contentFacadeId === this.state.journal.contentFacadeId
			if (response2.status === 200 )
			{
				this.message = "Success";
			}
			else
			{
				 this.message = "Failed";
			}        
			console.log(this.message);
			 // 
			event.preventDefault();
			//response.send(this.message);
			
		  })
			  .catch(err => {
			 console.log("error - " + err);
		  });
			  console.log("message info - " + this.message); 
		this.handleClear();
			
		//});
		
		
			console.log("SetState Message info-"+this.contentFacadeTypeId);
			console.log("SetState Message info-"+this.contentFacadeName);
			
	 };
	 handleClear(){
		 this.setState({journal : {}})
	 }
	 componentDidMount() 
	 {
	 	this.handleOnLoad();
	 }

	handleOnLoad = () => {
      axios.get(`${global.config.apiServicesUrl}/journals/${this.state.journal.journalsId}`).then(res => {

	      	this.setState({ journal : res.data });
    	  	console.log(res.data[0]);

 			//resolve drop down lists
			{
				//journalStatusCodeList
				var url1 = `${global.config.sharedServicesUrl}/code-catalog-data-service/get-system-code-values/JOURNAL_STATUS_CODE`;
					axios.get(url1)
					.then(response =>{
 					this.setState({journalStatusCodeList : response.data});
					}).catch(function (error) {
						console.log("Error:"+error);
					});		
			}	      	
      		//resolve user names			
				 {
					axios.get(`${global.config.securityServicesUrl}/user-profile-service/userprofile/username/${this.state.journal.createUserId}`)
					.then(response =>{
 					this.setState({createUserName : response.data});
					}).catch(function (error) {
						console.log("Error:"+error);
					});		
					axios.get(`${global.config.securityServicesUrl}/user-profile-service/userprofile/username/${this.state.journal.lastUpdateUserId}`)
					.then(response =>{
 					this.setState({lastUpdateUserName : response.data});
					}).catch(function (error) {
					console.log("Error:"+error);
					});		
				}
		})
		.catch(function (error){
		})
	 }
	
	render(){
    return (
        				<div class="m-content">				
			<div class="m-grid__item m-grid__item--fluid m-grid m-grid--ver-desktop m-grid--desktop m-body">
       				<div class="m-grid__item m-grid__item--fluid m-wrapper">
					<div class="m-subheader ">					
						<div class="d-flex align-items-center">
							<div class="mr-auto">
								<h3 class="m-subheader__title m-subheader__title--separator">Gazelle VLM</h3>
								<ul class="m-subheader__breadcrumbs m-nav m-nav--inline">
									<li class="m-nav__item m-nav__item--home">
										<Link to="/" class="m-nav__link m-nav__link--icon">
											<i class="m-nav__link-icon la la-home"></i>
										</Link>
									</li>
									<li class="m-nav__separator">-</li>
									<li class="m-nav__item">
										<Link to="/" class="m-nav__link">
											<span class="m-nav__link-text">Home</span>
										</Link>
									</li>
								</ul>
							</div>
							<div>
								<span class="m-subheader__daterange" id="m_dashboard_daterangepicker">
									<span class="m-subheader__daterange-label">
										<span class="m-subheader__daterange-title"></span>
										<span class="m-subheader__daterange-date m--font-brand"></span>
									</span>
									<a href="#" class="btn btn-sm btn-brand m-btn m-btn--icon m-btn--icon-only m-btn--custom m-btn--pill">
										<i class="la la-angle-down"></i>
									</a>
								</span>
							</div>
						</div>
						<br />

					<div className="content-wrapper">
		
		<form>
		<div class="container-fluid">
		<h4>Create Journal Entry</h4>
		<hr />
		

		<div class="form-group row" >
		<label class="ContentTitle col-sm-2" >Journal Name</label>
		<input id="journalName" class="form-control input-medium col-sm-8" value={this.state.journal.journalName} onChange ={this.handleChange}/>
		</div>
			<div class="form-group row" >
		<label class="ContentTitle col-sm-2" >Journal Owner</label>
		<input id="ownerUserId" class="form-control input-medium col-sm-8" value={this.state.journal.ownerUserId} onChange ={this.handleChange}/>
		</div>
			<div class="form-group row" >
		<label class="ContentTitle col-sm-2" >Project</label>
		<input id="projectId" class="form-control input-medium col-sm-8" value={this.state.journal.projectId} onChange ={this.handleChange}/>
		</div>
			<div class="form-group row" >
		<label class="ContentTitle col-sm-2" >Desktop</label>
		<input id="desktopId" class="form-control input-medium col-sm-8" value={this.state.journal.desktopId} onChange ={this.handleChange}/>
		</div>
		<div class="form-group row" >
		<label class="ContentTitle col-sm-2" >Content</label>
		<input id="contentId" class="form-control input-medium col-sm-8" value={this.state.journal.contentId} onChange ={this.handleChange}/>
		</div>

			<div class="form-group row" >
			<label class="ContentTitle col-sm-2" >Journal Status</label>
			<select id="journalStatusCode" class="form-control input-medium col-sm-8" value={this.state.journal.journalStatusCode} onChange ={this.handleChange}>
			{
				this.state.journalStatusCodeList.map((status) => {
					return (
						<option key={status.systemCodeValueId} value={status.systemCodeValueId}>{status.systemCodeValueValue}</option>
					)
				})
			}
			</select>
			</div>
				<div class="form-group row" >
			<label class="ContentTitle col-sm-2" >Description</label>
			<input id="journalDescr" class="form-control input-medium col-sm-8" value={this.state.journal.journalDescr} onChange ={this.handleChange}/>
			</div>
				<div class="form-group row" >
			<label class="ContentTitle col-sm-2" >Journal Entry</label>
			<input id="journalEntry" class="form-control input-medium col-sm-8" value={this.state.journal.journalEntry} onChange ={this.handleChange}/>
			</div>
				<div class="form-group row" >
			<label class="ContentTitle col-sm-2" >Alert Flag</label>
			<input id="journalAlertFlag" class="form-control input-medium col-sm-8" value={this.state.journal.journalAlertFlag} onChange ={this.handleChange}/>
			</div>
				<div class="form-group row" >
			<label class="ContentTitle col-sm-2" >Journal Reminder Flag</label>
			<input id="journalReminderFlag" class="form-control input-medium col-sm-8" value={this.state.journal.journalReminderFlag} onChange ={this.handleChange}/>
			</div>
				<div class="form-group row" >
			<label class="ContentTitle col-sm-2" >Attachments</label>
			<select id="journalAttachments" class="form-control input-medium col-sm-8" value={this.state.journal.journalAttachments} onChange ={this.handleChange}/>
			</div>
				<div class="form-group row" >
			<label class="ContentTitle col-sm-2" >Participants</label>
			<select id="journalParticipants" class="form-control input-medium col-sm-8" value={this.state.journal.journalParticipants} onChange ={this.handleChange}/>
			</div>
				<div class="form-group row" >
			<label class="ContentTitle col-sm-2" >Entry Date</label>
			<input id="journalEntryDate" class="form-control input-medium col-sm-8" value={this.state.journal.journalEntryDate} onChange ={this.handleChange}/>
			</div>
				<div class="form-group row" >
			<label class="ContentTitle col-sm-2" >Effective Date</label>
			<input id="effectiveDate" class="form-control input-medium col-sm-8" value={this.state.journal.effectiveDate} onChange ={this.handleChange}/>
			</div>
				<div class="form-group row" >
			<label class="ContentTitle col-sm-2" >Expiration Date</label>
			<input id="expirationDate" class="form-control input-medium col-sm-8" value={this.state.journal.expirationDate} onChange ={this.handleChange}/>
			</div>

		

		<hr />	
					
					<button class="btn btn-primary" value="Clear" onClick ={this.handleClear}>Clear</button> &nbsp;
					<button class="btn btn-success" value="Create" onClick ={this.handleSubmit}>Create</button>&nbsp;
		</div>		
		</form>
						</div>		

	            </div>	
            </div>
            
			</div>
			</div>
	);
}
}